import { LOGOUT } from '../../../store/Types';

export const ALL_ESTATUS = 'ALL_ESTATUS';
export const ACTIVO_ESTATUS = 'ACTIVO_ESTATUS';
export const LOADING_ALL_ESTATUS = 'LOADING_ALL_ESTATUS';
export const PARAMS_ESTATUS = 'PARAMS_ESTATUS';

const initialState = {
  all: [],
};

export const estatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ESTATUS:
      return {
        ...state,
        all: action.payload.data,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
